/** Same filename rule the API enforces (`docs/EVENT_QUEST_SNBT_DOCS.md` §2.3). */
export const SNBT_FILENAME = /^[a-zA-Z0-9][a-zA-Z0-9._-]*\.snbt$/i;
export const SNBT_MAX_BYTES = 2 * 1024 * 1024;

export function isSnbtFilename(name: string): boolean {
  return SNBT_FILENAME.test(name);
}

export function validateSnbtUpload(file: { name: string; size: number }): string | null {
  if (!isSnbtFilename(file.name)) {
    return 'Only .snbt files with a safe filename are accepted.';
  }
  if (file.size > SNBT_MAX_BYTES) {
    return `${file.name} exceeds the 2 MiB limit.`;
  }
  return null;
}

export function validateSnbtUploads(files: { name: string; size: number }[]): {
  accepted: { name: string; size: number }[];
  error: string | null;
} {
  const accepted = files.filter((f) => isSnbtFilename(f.name));
  if (accepted.length === 0) {
    return { accepted: [], error: 'Only .snbt files with a safe filename are accepted.' };
  }
  const oversized = accepted.find((f) => f.size > SNBT_MAX_BYTES);
  if (oversized) {
    return { accepted: [], error: `${oversized.name} exceeds the 2 MiB limit.` };
  }
  return { accepted, error: null };
}
